import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetBrands({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("BRAND_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/brand", option);
    commit("BRAND_SUCCESS", _response);
  } catch (error) {
    commit("BRAND_ERROR", { result: error.message });
  }
}

export async function CreateBrand({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("CREATE_BRAND_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/brand", form);
    commit("CREATE_BRAND_SUCCESS", _response);
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_BRAND_ERROR", { result: error.message });
  }
}

export async function GetBrand({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_BRAND_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/v1/brand/brand-id/", id);
    commit("GET_BRAND_SUCCESS", _response.data);
  } catch (error) {
    commit("GET_BRAND_ERROR", { result: error.message });
  }
}

export async function UpdateBrand({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_BRAND_REQUEST");
    ApiService.setHeader();
    await ApiService.put("/v1/brand/" + form.brandId, form);
    commit("EDIT_BRAND_SUCCESS", form);
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_BRAND_ERROR", { result: error.message });
  }
}

export async function DeleteBrand({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_BRAND_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/brand/" + id);
    commit("DELETE_BRAND_SUCCESS", { id: id });
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_BRAND_ERROR", { result: error.message });
  }
}
